import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isLoggedIn } from "../../helpers";

// Makes sure that only logged in users are able to view the Route
export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);
